import { useContext } from 'react'
import { EditableWish } from './types'
import { LootContext, PersonalLootContext } from './context'
import { difficulties } from 'app/frontend/types/custom/Difficulty'
import { useTeam } from 'app/frontend/base/config/context/team'
import WishLegacyPriority from 'app/frontend/types/custom/WishLegacyPriority'

export const useFindRelevantWish = (currentSpecId: number) => {
  const { difficulty, configuration } = useContext(LootContext)
  const { changes } = useContext(PersonalLootContext)

  return (item: wowaudit.WishlistItem, isVoidforged = false) => {
    const wishId = `${item.id}-${difficulty}-${currentSpecId}-${configuration.id}`

    return (
      (!isVoidforged && changes[wishId]) ||
      item.wishes.find(
        (wish) =>
          wish.difficulty === difficulties.indexOf(difficulty) &&
          wish.specialization === currentSpecId &&
          configuration.id === wish.configuration_id &&
          !!wish.voidforged === isVoidforged,
      )
    )
  }
}

export const VOIDFORGED_ILVL: Record<number, number> = { 0: 298, 1: 285 }

// Wowhead bonus ids that render the Voidforged version of an item (difficulty
// index 0 = mythic, 1 = heroic).
export const VOIDFORGED_BONUS_ID: Record<number, number> = {
  0: 13654,
  1: 13653,
}

// Matched against the normalized `display_slot`, which folds the various weapon
// item types into one_hand / two_hand / ranged / off_hand.
export const VOIDFORGED_SLOTS = [
  'one_hand',
  'two_hand',
  'ranged',
  'off_hand',
  'trinket',
]

export const wishEmpty = (wish?: EditableWish) => {
  return !wish || wish.type === 'none'
}

export const levelColors = {
  huge: 'bg-destructive-foreground',
  big: 'bg-warning-foreground',
  small: 'bg-success-foreground',
  tiny: 'bg-muted-foreground',
  none: 'bg-transparent',
}

export const defaultWishLabels: Record<WishLegacyPriority, string> = {
  huge: 'Huge',
  big: 'Big',
  small: 'Small',
  tiny: 'Tiny',
  none: 'None',
}

export const useWishLabels = (): Record<WishLegacyPriority, string> => {
  const { team } = useTeam()

  return {
    huge: team.settings.wishlistLabelHuge.value || defaultWishLabels.huge,
    big: team.settings.wishlistLabelBig.value || defaultWishLabels.big,
    small: team.settings.wishlistLabelSmall.value || defaultWishLabels.small,
    tiny: team.settings.wishlistLabelTiny.value || defaultWishLabels.tiny,
    none: defaultWishLabels.none,
  }
}

export const useAllowedWishLabels = (): WishLegacyPriority[] => {
  const { team } = useTeam()
  return team.settings.wishlistAllowedLabels.value as WishLegacyPriority[]
}
